export enum MavenVersion {
  '3_5' = '3.5',
  '3_8' = '3.8',
  '3_9' = '3.9'
}

export enum JavaVersion {
  '8_0' = '8.0',
  '11_0' = '11.0',
  '17_0' = '17.0'
}

export enum DefaultVersion {
  javaVersion = JavaVersion['8_0'],
  mavenVersion = MavenVersion['3_8']
}

export enum AccountType {
  FREE = 'free',
  ENTERPRISE_TRIAL = 'enterprise-trial',
  ENTERPRISE_POC = 'enterprise-poc',
  ENTERPRISE = 'enterprise'
}
